// @ts-check
export class JobOverlapModalController {
  /* @ngInject */
  constructor ($mdDialog, message) {
    this.$mdDialog = $mdDialog;
    this.message = message;
  }

  cancel = () => {
    this.$mdDialog.cancel();
  }
}
